import Vue from 'vue'

Vue.component('audit-checkpoint-finding-attribute', () => import('./Attribute.vue'))
Vue.component('audit-checkpoint-finding-route', () => import('./Route.vue'))
Vue.component('attribute-output-string', () => import('./Attribute/String.vue'))
Vue.component('attribute-output-boolean', () => import('./Attribute/Boolean.vue'))
Vue.component('attribute-output-array', () => import('./Attribute/Array.vue'))
Vue.component('attribute-output-object', () => import('./Attribute/Object.vue'))
Vue.component('attribute-output-integer', () => import('./Attribute/Integer.vue'))